
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Icon } from "@/types/icons";
import IconChooserDialog from "./IconChooserDialog.vue";
import { IconOptions } from "@/types/controls";
import IconComponent from "@/components/UI/Icon.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import MediaChooserLayer from "@/components/Reusable/CustomInputs/MediaInput/MediaChooserLayer.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import {
  readFromClipboard,
  writeToClipboard
} from "@/lib/copy-paste/copy-paste";

@Component({
  components: {
    Dropdown,
    MediaChooserLayer,
    NiceButton,
    IconComponent,
    IconChooserDialog
  }
})
export default class IconInput extends Vue {
  @Prop()
  value: Icon | undefined;

  @Prop()
  iconOptions!: IconOptions | null;

  dialogOpen = false;

  contextMenuOpen = false;
  contextMenuX = 0;
  contextMenuY = 0;

  get currentSvgCode() {
    return this.value?.svgCode;
  }

  openDialog() {
    this.dialogOpen = true;
  }

  closeDialog() {
    this.dialogOpen = false;
  }

  chooseIcon(icon: Icon) {
    this.dialogOpen = false;
    this.$emit("input", {
      ...icon
    });
  }

  clear() {
    this.$emit("input", {});
  }

  openContextMenu(e: MouseEvent) {
    this.contextMenuX = e.clientX;
    this.contextMenuY = e.clientY;

    this.contextMenuOpen = true;
  }

  copy() {
    if (!this.currentSvgCode) return;
    writeToClipboard(this.currentSvgCode);
  }

  async paste() {
    const text = await readFromClipboard();
    this.$emit("input", {
      ...this.value,
      svgCode: text
    });
  }
}
